import { render, staticRenderFns } from "./User-login.vue?vue&type=template&id=1b3a4b2d&scoped=true"
import script from "./User-login.vue?vue&type=script&lang=js"
export * from "./User-login.vue?vue&type=script&lang=js"
import style0 from "./User-login.vue?vue&type=style&index=0&id=1b3a4b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a4b2d",
  null
  
)

export default component.exports